import axios from '@/libs/api.request';
import search from '@/libs/search';
import axiosRequest from 'axios';
import { getAreaList } from '@/api/modules/system-management/area-management';

export const getDistributionStationList = data => {
    return axios.request({
        url: 'api/systemManagement/distributionStationManagement/getDistributionStationList',
        data: data,
        method: 'post'
    });
};

export const saveDistributionStation = data => {
    return axios.request({
        url: 'api/systemManagement/distributionStationManagement/saveDistributionStation',
        data: data,
        method: 'post'
    });
};

export const saveDistributionStationYsDept = data => {
    return axios.request({
        url: 'api/systemManagement/distributionStationManagement/saveDistributionStationYsDept',
        data: data,
        method: 'post'
    });
};


export const pageInit4DistributionStationEdit = () => {
    const areaSearch = search.getSearchParams({ closeAllConditions: true });

    return axiosRequest.all([
        getAreaList(areaSearch)
    ]).then(axiosRequest.spread(function (area) {
        if (area.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    area: area.data
                }
            };
        }
    }));
};

export const getDistributionStationBlockDistList = () => {
    return axios.request({
        url: 'api/systemManagement/distributionStationManagement/getDistributionStationBlockDistList',
        data: {},
        method: 'post'
    });
};

export const addDistributionStationBlockDist = data => {
    return axios.request({
        url: 'api/systemManagement/distributionStationManagement/addDistributionStationBlockDist',
        data: data,
        method: 'post'
    });
};

export const removeDistributionStationBlockDist = data => {
    return axios.request({
        url: 'api/systemManagement/distributionStationManagement/removeDistributionStationBlockDist',
        data: data,
        method: 'post'
    });
};

export const getDistributionStationToCustomerCostSetting = () => {
    return axios.request({
        url: 'api/systemManagement/distributionStationManagement/getDistributionStationToCustomerCostSetting',
        data: {},
        method: 'post'
    });
};

export const saveDistributionStationToCustomerCostSetting = data => {
    return axios.request({
        url: 'api/systemManagement/distributionStationManagement/saveDistributionStationToCustomerCostSetting',
        data: data,
        method: 'post'
    });
};
